<template>
  <div class="cmp cmp-footer">
    <div class="flex-center">
      <a href="javascript:;">帮助中心</a>
      <a href="javascript:;">关于我们</a>
      <a href="javascript:;">联系我们</a>
      <a href="javascript:;">意见反馈</a>
      <a href="javascript:;">用户协议</a>
      <a href="javascript:;">隐私政策</a>
    </div>
    <div class="flex-center">
      <a href="javascript:;">版权所有 北京京师讯飞教育科技有限公司</a>
      <a href="javascript:;">网站备案编号：<span>京ICP备16045443号-4</span></a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010202008407"><span>京公网安备11010202008407号</span></a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cmp-footer',
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.cmp-footer {
  z-index: 2;
  width: 100%;
  padding: 20px 40px;
  background-color: #363636;
  a {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    margin: 0 15px;
    color: #999999;
    font-size: 14px;
    text-decoration: none;
    position: relative;
    &:hover {
      span {
        color: #358bff;
      }
    }
    &:not(:last-child)::after {
      content: "";
      position: absolute;
      right: -15px;
      top: 10px;
      bottom: 10px;
      width: 1px;
      background-color: #999999;
    }
  }
}
</style>
